import { useEffect } from 'react';

/**
 * iOS viewport 修复 hook
 *
 * 解决 iOS 设备上 100vh 高度问题，确保布局正确填充整个视口
 */
export const useIOSViewportFix = () => {
  useEffect(() => {
    // 获取实际视口高度
    const setViewportHeight = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}rem`);
    };

    setViewportHeight();
    window.addEventListener('resize', setViewportHeight);
    window.addEventListener('orientationchange', setViewportHeight);

    return () => {
      window.removeEventListener('resize', setViewportHeight);
      window.removeEventListener('orientationchange', setViewportHeight);
    };
  }, []);
};
